import { Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikTextField from "../../../../commons/formik/FormikTextField";
import { StyledRgrl } from "../../../../styled/Prevencion";

const initialValues = {
  cuit: "",
  detalle: "",
};

const addContratistaValidation = Yup.object({
  cuit: Yup.string()
    .matches(/\d{11}/, "Ingrese solo números")
    .required("Campo obligatorio"),
  detalle: Yup.string()
    .max(200, "No se permiten más de 200 caracteres")
    .required("Campo obligatorio"),
});

const AddContratistaDialog = ({ open, handleClose, handleSubmit }) => {

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>Seleccionar Contratista</DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={addContratistaValidation}
      >
        <Form>
          <DialogContent>
            <StyledRgrl.RowContainer>
              <FormikTextField name="cuit" label="CUIT" fullWidth />
            </StyledRgrl.RowContainer>
            <StyledRgrl.RowContainer>
              <FormikTextField
                name="detalle"
                label="Nombre / Observación"
                fullWidth
                multiline
              />
            </StyledRgrl.RowContainer>
          </DialogContent>
          <DialogActions>
            <FormikActions handleCancel={handleClose}></FormikActions>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default AddContratistaDialog;
